import React from 'react';
import { productBenefits } from '../../data/productBenefits';
import type { Product } from '../../types/product';
import { Reveal } from '../ui/Reveal';
export function WhyGood({
  product
}: {
  product: Product;
}) {
  const items = productBenefits[product.slug];
  if (!items?.length) return null;
  const living = product.line === 'living';
  return <section className="bg-surface" aria-labelledby="why-good" data-id="element-480" data-mp="2eofg84ysjkj9">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-481" data-mp="20xsqh2b0d4zb">
        <Reveal data-id="element-482" data-mp="25pahoyn8br73">
          {living ? <h2 id="why-good" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-483" data-mp="25qc0xqeefjzw">
              Waarom je {product.name.toLowerCase()} wilt
            </h2> : <h2 id="why-good" className="font-display text-4xl uppercase tracking-display text-ink sm:text-5xl" data-id="element-484" data-mp="1w0is2x5n5izc">
              Waarom {product.name} <em className="italic text-pink" data-id="element-485" data-mp="1i22kl3zyfog5">goed voor je is</em>
            </h2>}
        </Reveal>
        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-486" data-mp="p9eij9gbg0vj">
          {items.map((b, i) => <li key={b.title} className="h-full" data-id="element-487" data-mp="l7tbi4qgqgt9" data-mpi={i}>
              <Reveal delay={i * 0.05} className={`flex h-full flex-col bg-white p-8 ${living ? 'rounded-xl' : ''}`} data-id="element-488" data-mp="l71eqql4qd1e">
                <h3 className={living ? 'text-xl font-semibold text-majorelle' : 'font-display text-2xl tracking-display text-berry'} data-id="element-489" data-mp="z6sxt5qi6jm9">{b.title}</h3>
                <p className="mt-3 text-[17px] font-light leading-relaxed text-muted" data-id="element-490" data-mp="6idngwibgph9">{b.text}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}